import React, {FunctionComponent, useState} from 'react';
import Response from '../../../../networking/models/Response';
import HanCheckbox from '../../../utils/HanCheckbox';
import HanButton from '../../../utils/HanButton';

import { ReactComponent as ArrowRight } from '../../../../assets/icons/icon_arrow_right.svg';
import Card from '../../../layout/Card';

interface Props {
    response: Response;
    onClick: (response: Response) => void;
    onResponseChange: (response: Response) => void;
}

const ResponseCard: FunctionComponent<Props> = ({ response, onClick, onResponseChange }) => {
    const [active, setActive] = useState<boolean>(response.is_archived!);
    const [contactable, setContactable] = useState<boolean>(response.is_contact);

    const onDetailButtonClick = () => onClick(response);

    const toggleActive = () => {
        const newActive = !active;

        onResponseChange({ ...response, is_archived: newActive });
        setActive(!active);
    };

    const toggleContactable = () => {
        const newContactable = !contactable;

        onResponseChange({ ...response, is_contact: newContactable });
        setContactable(newContactable);
    };

    return (
        <Card className={'response-card'}>
            <div className={'response-card__content response-card__content--left'}>
                <span className={'response-card__title'}>Response - { response.first_name } { response.last_name }</span>

                <div className={'flex flex--column'}>
                    <span className={'response-card__text'}>{ response.email_han ?? response.email_private }</span>
                    <span className={'response-card__text'}>{ response.date_of_birth }</span>
                </div>
            </div>

            <div className={'response-card__content response-card__content--right'}>
                <div className={'response-card__tooltip'}>
                    <span className={'response-card__tooltip-text'}>
                        { contactable ? '(Student wants to be contacted)' : '' }
                    </span>

                    <HanCheckbox onClick={toggleContactable} checked={contactable} />
                </div>


                <div className={'response-card__actions'}>
                    <HanButton onClick={toggleActive} disabled={active}>Activate</HanButton>
                    <HanButton onClick={toggleActive} disabled={!active}>Deactivate</HanButton>
                    <HanButton onClick={onDetailButtonClick}>Details <ArrowRight className={'response-card__icon'} /></HanButton>
                </div>
            </div>
        </Card>
    );
};

export default ResponseCard;
